import Vapi from 'vuex-rest-api';

const fetcherAdminFeedRule = new Vapi({
  state: {
    fetcherAdminFeedRule: {
      id: 0,
    },
  },
})
  .get({
    action: 'getFetcherAdminFeedRule',
    property: 'fetcherAdminFeedRule',
    path: ({ frid }) => `/api/fetcher/admin/feedRules/${frid}`,
  })
  .getStore();

export default fetcherAdminFeedRule;
